import groupEntities from '../../../group-entities';
export default function groupNodeEntities(entities, options) {
  const {
    interval
  } = options;
  const entitySet = [...entities];
  const chunks = [];
  let lastSliceIndex = 0;
  const validNodeIndexes = entitySet.map(({
    props
  }, validIndex) => {
    const hasValidChildren = props && props.children && props.children.length;
    if (hasValidChildren) return validIndex;
    return null;
  }).filter(indexCandidate => typeof indexCandidate === 'number');
  const refChunks = groupEntities(validNodeIndexes, interval - 1);
  refChunks.forEach(ref => {
    const end = ref[ref.length - 1] + 1;
    const start = lastSliceIndex || ref[0];
    const newChunk = entitySet.slice(start, end);
    lastSliceIndex = end;
    if (newChunk.length) chunks.push(newChunk);
  });
  return chunks;
}
//# sourceMappingURL=group-node-entities.js.map